import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hamn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Något gick fel. Försök igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
export default api;

export async function downloadCvPdf(cvId, filename = "HAMN_CV.pdf") {
  try {
    const res = await api.get(`/cvs/${cvId}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    const detail = await blobErrorDetail(err);
    throw new Error(detail || `Nedladdning misslyckades (${err?.response?.status || "nätverksfel"}).`);
  }
}

export async function downloadCvDocx(cvId, filename = "HAMN_CV.docx") {
  try {
    const res = await api.get(`/cvs/${cvId}/docx`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    const detail = await blobErrorDetail(err);
    throw new Error(detail || `Nedladdning misslyckades (${err?.response?.status || "nätverksfel"}).`);
  }
}

async function blobErrorDetail(err) {
  try {
    const data = err?.response?.data;
    if (data instanceof Blob) {
      const text = await data.text();
      try { return JSON.parse(text).detail; } catch { return text; }
    }
    return data?.detail;
  } catch { return undefined; }
}

export async function downloadCoverLetterPdf(letterId, filename = "HAMN_Brev.pdf") {
  try {
    const res = await api.get(`/cover-letters/${letterId}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    const detail = await blobErrorDetail(err);
    throw new Error(detail || `Nedladdning misslyckades (${err?.response?.status || "nätverksfel"}).`);
  }
}

export async function downloadCoverLetterDocx(letterId, filename = "HAMN_Brev.docx") {
  try {
    const res = await api.get(`/cover-letters/${letterId}/docx`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  } catch (err) {
    const detail = await blobErrorDetail(err);
    throw new Error(detail || `Nedladdning misslyckades (${err?.response?.status || "nätverksfel"}).`);
  }
}

export async function downloadReferenceAttachment(attachmentId, filename = "intyg") {
  const res = await api.get(`/references/attachments/${attachmentId}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadReferenceDimensionsPdf(filename = "HAMN_Referensstyrkor.pdf") {
  const res = await api.get(`/references/dimensions-pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
